export default __webpack_public_path__ + "media/images/svg/magnifier-812971d2e1770a93065e54df2c01d4de.svg";